var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("pui-navigation-toolbar", {
    attrs: { "link-items": _vm.navBarLinks },
    on: { "clicked:tab": _vm.handleClick },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }